import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-627cf3b4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-wrapper"
};
const _hoisted_2 = {
  class: "course-content"
};
const _hoisted_3 = {
  class: "main-title"
};
const _hoisted_4 = {
  class: "link-list"
};
const _hoisted_5 = {
  class: "text"
};
const _hoisted_6 = ["href"];

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-text"
}, "查看全部", -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icongengduo"
}, null, -1));

const _hoisted_9 = [_hoisted_7, _hoisted_8];
const _hoisted_10 = {
  class: "course-list"
};
const _hoisted_11 = {
  key: 1,
  class: "no-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CourseCard = _resolveComponent("CourseCard");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString($props.menu.menu_name), 1)]), _createElementVNode("a", {
    href: `/courseList.html?type=2&name=${$props.menu.menu_name}&menuId=${$props.menu.id}`,
    class: "more-btn",
    style: {
      "margin-top": "6px"
    }
  }, _hoisted_9, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_10, [$data.homeCourseList && $data.homeCourseList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.homeCourseList, course => {
    return _openBlock(), _createBlock(_component_CourseCard, {
      class: "home-course-card",
      info: course,
      key: course.courseId,
      "show-label": true,
      userInfo: $props.userInfo,
      authType: $data.authType
    }, null, 8, ["info", "userInfo", "authType"]);
  }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_Empty)]))])])]);
}